import { call, put, select, takeLatest } from 'redux-saga/effects';
import braintreeService from '../services/braintree';
import { selectConfig } from '../features/config/configSlice';
import { selectUserAccessToken } from '../features/user/userSlice';

/**
 * Get Braintree client token
 */
export function* getClientToken() {
  const config = yield select(selectConfig);
  const clientToken = yield call(braintreeService.getClientToken, config);

  try {
    yield put({
      type: 'braintree/getClientTokenSuccess',
      payload: {
        clientToken,
      },
    });
    return clientToken;
  } catch (e) {
    console.error('get braintree client token error', e);
    yield put({ type: 'braintree/getClientTokenFailure', payload: clientToken });
  }
}

export function* checkout({ payload: { amount, railcardId, deviceData, nonce } }) {
  const token = yield select(selectUserAccessToken);

  const config = yield select(selectConfig);

  try {
    yield put({ type: 'braintree/checkoutProcessing' });

    const result = yield call(braintreeService.checkout, {
      amount,
      railcardId,
      deviceData,
      nonce,
      token,
      config,
    });

    const paymentSuccessful = result?.payment?.success;

    if (!paymentSuccessful) {
      yield put({ type: 'braintree/checkoutFailure' });
      yield put({
        type: 'globalModals/openErrorModal',
        payload: {
          message:
            'Sorry, an error occured attempting to check out with Braintree. Please try again later.',
          title: 'Braintree checkout error',
        },
      });
      throw new Error('Braintree checkout error');
    } else {
      yield put({ type: 'braintree/checkoutSuccess' });
      yield put({
        type: 'pendingRailcard/setPaid',
        payload: {
          paidWith: 'braintree',
        },
      });
    }
  } catch (e) {
    yield put({ type: 'braintree/checkoutFailure' });
    // Hack, because this service doesnt' return proper AuthError responses
    const isAuthError = e.message.includes('The suppli');

    if (isAuthError) {
      yield put({ type: 'login/userLogout' });
      yield put({
        type: 'globalModals/openErrorModal',
        payload: {
          message:
            'Your session has expired and your basket has been cleared. Please log in and try again.',
          title: 'Error during Braintree checkout',
        },
      });
    }
  }
}

function* braintreeSaga() {
  yield takeLatest('braintree/getClientToken', getClientToken);
  yield takeLatest('braintree/checkout', checkout);
}

export default braintreeSaga;
